import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { obtenerEntityValues } from '../../../Autocomplete/actions'
import { renderSelectField } from '../../fieldRenderers'
import { required, validAutocomplete } from '../../fieldValidators'

function EntitySelect (props) {
  const { entityValues = [], entity, name = 'entity', placeholder, label, autoFocus, required: isRequired = false, value = '', obtenerEntityValues } = props

  useEffect(() => {
    obtenerEntityValues(entity, props.orderBy)
  }, [obtenerEntityValues, entity, props.orderBy])

  const values = entityValues || []
  const validators = [validAutocomplete]
  if (isRequired) validators.push(required)

  const renderEntity = () => {
    const options = entityValues.map((e) => {
      const v = `${e.razonSocial} - ${e.cuit}`
      return (
        <option
          value={v}
          key={v}
        >
          {v}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  return (
    <Field
      name={name}
      label={label}
      component={renderSelectField}
      validate={validators}
      entity={entity}
      placeholder={placeholder}
      values={values}
      autoFocus={autoFocus}
      type='text'
      value={value}
      onChange={(value) => { props.onChange(value.target.value) }}
    >
      {renderEntity()}
    </Field>
  )
}

const mapStateToProps = (state, ownProps) => ({
  entityValues: state.autocomplete.entityValues[ownProps.entity]
})

const mapActionsToProps = {
  obtenerEntityValues
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(EntitySelect)
